import { DynamicExportCategory, DynamicExportKey } from '@Constants/dynamicExportConstants';
import { type SelectOption } from '@synqo/frontend-component-library';

export function getUniqueExportIdentifier(category: string, key: string) {
    return `${category}:${key}`;
}

export const exportTypeOptions: SelectOption<string>[] = [
    {
        name: 'accounting',
        value: getUniqueExportIdentifier(DynamicExportCategory.Invoices, DynamicExportKey.Accounting),
        label: 'FiBu-Export',
    },
    {
        name: 'cash_journal',
        value: getUniqueExportIdentifier(DynamicExportCategory.CashJournals, DynamicExportKey.Positions),
        label: 'Kassenbuch-Export',
    },
];
